import { useLenis } from "../lib/useLenis";
import { useEffect } from "react";
import { install as installHeatmap } from "../lib/heatmap";
import { install as installConsentedHistory, pageview as consentedPageview } from "../lib/consented-history";
import { BuyProvider } from "../components/site/BuyProvider";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { BookChapters } from "../components/site/BookChapters";
import { AuthorSection, MonicaSection } from "../components/site/Author";
import { FinalCTA } from "../components/site/FinalCTA";
import { Footer } from "../components/site/Footer";
import {
  ProblemSection,
  WhatIsSection,
  TruthWithin,
  NotSelfHelp,
  RootsSection,
  EnergySection,
} from "../components/site/Sections";

export default function Landing() {
  useLenis();
  useEffect(() => {
    // Fire-and-forget: install() is a no-op until the server-side flag
    // returns {enabled:true} AND iubenda Measurement consent is present.
    installHeatmap(process.env.REACT_APP_BACKEND_URL);
    // First-party consented history — creates cvid + sid in
    // localStorage/sessionStorage only after iubenda purpose 4 is granted.
    installConsentedHistory(process.env.REACT_APP_BACKEND_URL);
  }, []);
  return (
    <BuyProvider>
      <div className="noise-overlay relative bg-primary" data-testid="landing">
        <Header />
        <main>
          <Hero />
          <ProblemSection />
          <WhatIsSection />
          <TruthWithin />
          <NotSelfHelp />
          <Marquee />
          <RootsSection />
          <EnergySection />
          <AuthorSection />
          <MonicaSection />
          <BookChapters />
          <FinalCTA />
        </main>
        <Footer />
      </div>
    </BuyProvider>
  );
}
